<template>
  <div>
    <div class="container-fluid">
      <div class="page-header">
        <Breadcrumbs main="" title="Dashboard" />
      </div>

      <div class="row">
        <div class="col-12">
          <div class="alert alert-info" role="alert">
            Choose a store below to open its admin panel. The global statistics
            of all stores are displayed underneath.
          </div>
        </div>
      </div>

      <Widget @stores-changed="load" />

      <div v-if="loading" class="text-center py-5">
        <div class="spinner-border text-primary" role="status"></div>
        <p class="mt-2 text-muted mb-0">Loading global statistics…</p>
      </div>

      <div v-else-if="error" class="alert alert-danger" role="alert">
        Unable to load global statistics: {{ error }}
      </div>

      <template v-else-if="global">
        <KpiCards :stats="global" />
        <div class="row">
          <SalesChart :stats="global" title="Sales per month · all stores" />
          <StoresOverview :stores="global.stores" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Widget from "../components/dashboard/widget.vue";
import KpiCards from "../components/dashboard/live/kpi-cards.vue";
import SalesChart from "../components/dashboard/live/sales-chart.vue";
import StoresOverview from "../components/dashboard/live/stores-overview.vue";
import { fetchAllStoresData, computeGlobalStats } from "../utils/store-stats";

export default {
  components: {
    Widget,
    KpiCards,
    SalesChart,
    StoresOverview
  },
  data() {
    return {
      global: null,
      loading: false,
      error: null
    };
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      this.error = null;
      try {
        const dataList = await fetchAllStoresData();
        this.global = computeGlobalStats(dataList);
      } catch (e) {
        console.error("Global dashboard load error:", e);
        this.error = e && e.message ? e.message : String(e);
        this.global = null;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
